/* eslint-disable max-len */
import React from "react"

import theme from "@irati/ui/src/global/theme"

import BaseSvgIcon from "../Base"

const Video = ({color = theme.colors.greys.white, size = 20, strokeWidth = 1.6, ...props}) => {
  return (
    <BaseSvgIcon {...{...props, size}} viewBox="0 0 20 20" fill="none">
      <path
        d="M17.9997 6.79834L13.1997 9.99834L17.9997 13.1983V6.79834Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6002 5.19971H3.60024C2.71659 5.19971 2.00024 5.91605 2.00024 6.79971V13.1997C2.00024 14.0834 2.71659 14.7997 3.60024 14.7997H11.6002C12.4839 14.7997 13.2002 14.0834 13.2002 13.1997V6.79971C13.2002 5.91605 12.4839 5.19971 11.6002 5.19971Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSvgIcon>
  )
}

export default Video
